module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }